import {
  Controller,
} from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.disconnects = -1;
    this.observer = new MutationObserver(() => {
      if (this.element.hasAttribute('connected')) {
        this.disconnects += 1;
        if (this.disconnects > 0) {
          const gallery = document.getElementById('gallery');
          if (gallery) gallery.reload();
        }
      }
    });

    this.observer.observe(this.element, { attributeFilter: ["connected"] });
  }

  disconnect() {
    this.observer.disconnect();
  }
}
